import {modalServiceSubject} from "../../services/modal.service";

export function showReplayErrorModal(message: string) {
    modalServiceSubject.next({
        title: "Kupon Yüklenemedi",
        innerHtml: true,
        content: `<div class="text-center"><p>${message}</p><p>Bu kupon artık aynen oynanamıyor. Dilerseniz seçimlerinizi kendiniz yapabilir ya da başka bir kupon deneyebilirsiniz.</p></div>`,
        confirm: {cancel: {label: "Tamam"}},
    });
}

// Kuponun bahis türü/koşusu kartta artık açık değilse.
export function showClosedTicketModal() {
    modalServiceSubject.next({
        title: "Kapanmış Bahis",
        innerHtml: true,
        content: '<div class="text-center"><p>Bu kupon artık oynanabilir değil. Farklı bir kupon yapabilir ya da yorumcularımızın diğer kuponlarını oynayabilirsiniz.</p></div>',
        confirm: {cancel: {label: "Tamam"}},
    });
}
